<template>
    <!-- how it works -->
    <div class="how-it-works-sec-two">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="me-5" data-aos="fade-up">
                        <img src="@/assets/img/gallery/gallery-03.webp" style="height: 835px; width: 800px;" class="img-fluid rounded-5" alt="img">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="how-it-works-content aos" data-aos="fade-up">
                    <div class="section-header">
                        <span class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block">Cara Kerja</span>
                        <h2 class="mb-1">Mulai Perjalanan Belajarmu Hari Ini</h2>
                        <p>Akses pelatihan internal, ikuti materi, kerjakan evaluasi, dan pantau progres belajar dalam satu platform.</p>
                    </div>
                    <div class="d-flex align-items-center works-items">
                        <span class="count">01</span>
                        <div>
                            <h5 class="mb-1">Masuk dengan Akun</h5>
                            <p>Gunakan akun yang sudah diberikan untuk login ke sistem.</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center works-items">
                        <span class="count">02</span>
                        <div>
                            <h5 class="mb-1">Lengkapi Profil</h5>
                            <p>Perbarui data diri seperlunya agar rekomendasi dan akses pelatihan sesuai peran.</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center works-items">
                        <span class="count">03</span>
                        <div>
                            <h5 class="mb-1">Pilih Modul Pelatihan</h5>
                            <p>Telusuri daftar pelatihan dan mulai modul yang ditugaskan atau yang kamu butuhkan.</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center works-items mb-0 pb-0 border-0">
                        <span class="count">04</span>
                        <div>
                            <h5 class="mb-1">Belajar & Pantau Progres</h5>
                            <p>Akses materi, kerjakan kuis/ujian bila ada, dan pantau progres serta hasil belajarmu.</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    <!-- how it works -->
</template>

<script>
import HomeClient from "@/assets/json/home-client.json";
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default {
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            HomeClient: HomeClient,
        }
    },
    setup() {
        return {
            // carousel settings
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },

            breakpoints: {
                // 700px and up
                700: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                // 1024 and up
                1024: {
                    itemsToShow: 6,
                    snapAlign: "start",
                },
            },
        };
    },
}
</script>
